import { Component, Vue } from 'vue-property-decorator'
import ProductSlides from '~/components/block/ProductSlides'
import MainSlider from '~/components/block/MainSlider'
import MainSliderAdvertisement from '~/components/block/MainSliderAdvertisement'
import MainSlideDelivery from '~/components/block/MainSlideDelivery'
import MainInfoBlock from '~/components/block/MainInfoBlock'
import MainDiseaseBlock from '~/components/block/MainDiseaseBlock'
import MainCatalogSectionsSlider from '~/components/block/MainCatalogSectionsSlider'
import ContraindicationsSvg from '~/assets/svg/contraindications.svg?inline'
import ContraindicationsMobileSvg from '~/assets/svg/contraindicationsMobile.svg?inline'
import loc from '~/utils/loc'
import s from '~/utils/s'
import mainPage from '~/store/mainPage'
import StocksSlide from '~/components/block/StocksSlides'

@Component
export default class MainPage extends Vue {
  mainPage: mainPage

  constructor () {
    super()
    this.mainPage = s(this.$store).mainPage
  }

  get isShowSlidesBlock (): boolean {
    return (
      this.mainPage.promotions.items.length > 0 ||
      this.mainPage.popular.items.length > 0 ||
        this.mainPage.products.items.length > 0
    )
  }

  get isShowStockSlide (): boolean {
    return this.mainPage.listForSlides.items.length > 0
  }

  async beforeMount () {
    s(this.$store).mainPage.fillData()
    const regionId = s(this.$store).regions.regionId
    const sectionId = s(this.$store).regions.sectionId
    s(this.$store).categoryPage.setDefaultCategory()
    await s(this.$store).staticPages.getStaticPage({ code: 'main', regionId, sectionId })
    const staticPage = s(this.$store).staticPages.staticPage
    if (staticPage && staticPage.code === 'main') {
      s(this.$store).seo.setTitle(staticPage.SEOTitle)
      s(this.$store).seo.setDescription(staticPage.SEODescription)
      s(this.$store).seo.setKeywords(staticPage.SEOKeywords)
    }
  }

  productsBlock () {
    if (this.mainPage.products.items.length > 0) {
      return (
        <div class="page-index__slides-block-container">
          <ProductSlides
            {...{
              props: {
                products: this.mainPage.products.items,
                title: 'Товары',
                location: loc(this.$store, {
                  name: 'catalog'
                })
              }
            }}
          />
        </div>
      )
    }
  }

  promotionsBlock () {
    if (this.mainPage.promotions.items.length > 0) {
      return (
        <div class="page-index__slides-block-container">
          <ProductSlides
            {...{
              props: {
                products: this.mainPage.promotions.items,
                title: 'Товары со скидкой',
                location: loc(this.$store, {
                  name: 'catalog-sale'
                })
              }
            }}
          />
        </div>
      )
    }
  }

  popularBlock () {
    if (this.mainPage.popular.items.length > 0) {
      return (
        <div class="page-index__slides-block-container">
          <ProductSlides
            {...{
              props: {
                products: this.mainPage.popular.items,
                title: 'Популярные товары',
                location: loc(this.$store, {
                  name: 'catalog-popular'
                })
              }
            }}
          />
        </div>
      )
    }
  }

  noveltiesBlock () {
    if (this.mainPage.novelties.items.length > 0) {
      return (
        <div class="page-index__slides-block-container">
          <ProductSlides
            {...{
              props: {
                products: this.mainPage.novelties.items,
                title: 'Новинки',
                location: loc(this.$store, {
                  name: 'catalog-novinki'
                })
              }
            }}
          />
        </div>
      )
    }
  }

  // TODO: сделать отдельные стили для прелоадера
  previewBlock () {
    return (
      <section class="page-index__preview-block">
        <div class="page-index__preview-block-container">
          <div class="page-index__main-slider_row">
            <div class={{
              'page-index__main-slider': true
              // 'page-index__main-slider_full': this.isShowMainSlider
            }}>
              <MainSlider />
            </div>

            <div class="page-index__main-slider-advertisement">
              <MainSliderAdvertisement />
            </div>
          </div>

          <div class="page-index__catalog-sections-slider">
            <MainCatalogSectionsSlider />
          </div>
        </div>
      </section>
    )
  }

  sliderBlock () {
    if (this.isShowSlidesBlock) {
      return (
        <section class="page-index__slides-block">
          {this.productsBlock()}
          {this.promotionsBlock()}
          {this.noveltiesBlock()}
          {this.popularBlock()}
        </section>
      )
    }
  }

  stocksBlock () {
    if (this.isShowStockSlide) {
      return (
        <section class="page-index__stoks-block">
          <div class="page-index__stoks-block-container">
            <StocksSlide
              {...{
                props: {
                  stocks: s(this.$store).mainPage.listForSlides.items,
                  title: 'Акции',
                  linkTitle: 'Все акции',
                  location: loc(this.$store, {
                    name: 'stock'
                  })
                }
              }}/>
          </div>
        </section>
      )
    }
  }

  diseaseBlock () {
    if (this.mainPage.diseaseSections.length > 0 &&
      s(this.$store).regions.sectionCode !== process.env.NUXT_ENV_SECTION_CODE_VETERINARIY) {
      return (
        <section class="page-index__disease-block">
          <MainDiseaseBlock
            {...{
              props: {
                items: this.mainPage.diseaseSections,
                location: loc(this.$store, {
                  name: 'diseases'
                })
              }
            }}
          />
        </section>
      )
    }
  }

  infoBlock () {
    return (
      <section class="page-index__info-block">
        <MainInfoBlock/>
      </section>
    )
  }

  contraindicationsBlock () {
    return (
      <div class="page-index__contraindications-block">
        <div class="page-index__contraindications-block-desktop">
          <ContraindicationsSvg/>
        </div>
        <div class="page-index__contraindications-block-mobile">
          <ContraindicationsMobileSvg/>
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="page-index">
        {this.previewBlock()}
        {this.sliderBlock()}
        {this.stocksBlock()}
        {this.diseaseBlock()}
        {this.infoBlock()}
        {this.contraindicationsBlock()}
      </div>
    )
  }
}
